var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 323.02 84.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #666;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.4,67.26V13.98h22.54c3.6,0,6.6.64,9,1.91,2.4,1.27,4.31,3.1,5.72,5.47s2.41,5.2,2.99,8.46c.58,3.26.86,6.87.86,10.8,0,6-.68,10.97-2.05,14.9-1.37,3.94-3.42,6.88-6.16,8.82-2.74,1.94-6.19,2.92-10.37,2.92h-22.54ZM103.06,57.68h10.8c2.21,0,3.96-.64,5.26-1.91,1.3-1.27,2.24-3.18,2.84-5.72.6-2.54.9-5.69.9-9.43,0-3.46-.19-6.3-.58-8.53-.38-2.23-.95-3.97-1.69-5.22-.74-1.25-1.68-2.11-2.81-2.59-1.13-.48-2.44-.72-3.92-.72h-10.8v34.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.35,67.69c-2.93,0-5.3-.86-7.13-2.59-1.83-1.73-2.74-4.13-2.74-7.2v-3.46c0-2.93,1.03-5.34,3.1-7.24,2.06-1.9,5.28-2.84,9.65-2.84h9.86v-2.66c0-1.2-.22-2.2-.65-2.99-.43-.79-1.24-1.37-2.41-1.73-1.18-.36-2.96-.54-5.36-.54h-11.59v-6.19c1.87-.58,4.04-1.08,6.52-1.51,2.47-.43,5.46-.65,8.96-.65,3.21,0,5.96.38,8.24,1.15,2.28.77,4.01,2.09,5.18,3.96,1.18,1.87,1.76,4.46,1.76,7.78v26.28h-8.42l-1.73-4.1c-.34.38-.91.82-1.73,1.3-.82.48-1.81.97-2.99,1.48-1.18.5-2.5.92-3.96,1.26-1.46.33-2.99.5-4.57.5ZM153.75,60.28c.48,0,1.02-.06,1.62-.18.6-.12,1.22-.26,1.87-.43.65-.17,1.25-.33,1.8-.5.55-.17,1.01-.32,1.37-.47.36-.14.59-.24.68-.29v-9l-6.48.43c-1.87.14-3.25.62-4.14,1.44-.89.82-1.33,1.92-1.33,3.31v1.58c0,.96.2,1.75.61,2.38.41.62.96,1.07,1.66,1.33.7.26,1.48.4,2.34.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.84,84.32l4.18-17.06c-2.16,0-4.06-.41-5.69-1.22-1.63-.82-2.99-1.98-4.07-3.49-1.08-1.51-1.91-3.4-2.48-5.65l-7.27-28.3h11.09l6.12,26.14c.24.91.55,1.63.94,2.16.38.53.79.9,1.22,1.12s.83.36,1.19.43c.36.07.64.11.83.11l6.98-29.95h10.8l-11.52,48.6-3.46,7.13h-8.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.8,67.69c-3.65,0-6.84-.35-9.58-1.04-2.74-.7-5.03-1.99-6.88-3.89-1.85-1.9-3.23-4.62-4.14-8.17-.91-3.55-1.37-8.18-1.37-13.9s.47-10.36,1.4-13.93c.94-3.58,2.32-6.32,4.14-8.24,1.82-1.92,4.1-3.24,6.84-3.96,2.74-.72,5.93-1.08,9.58-1.08s6.84.36,9.58,1.08c2.74.72,5.01,2.04,6.84,3.96,1.82,1.92,3.19,4.67,4.1,8.24.91,3.58,1.37,8.22,1.37,13.93s-.46,10.34-1.37,13.9c-.91,3.55-2.28,6.28-4.1,8.17-1.83,1.9-4.1,3.19-6.84,3.89-2.74.7-5.93,1.04-9.58,1.04ZM241.8,58.12c2.16,0,3.96-.24,5.4-.72,1.44-.48,2.58-1.33,3.42-2.56.84-1.22,1.45-2.98,1.84-5.26.38-2.28.58-5.24.58-8.89,0-3.84-.19-6.91-.58-9.22-.38-2.3-1-4.07-1.84-5.29-.84-1.22-1.98-2.05-3.42-2.48-1.44-.43-3.24-.65-5.4-.65s-3.82.22-5.26.65c-1.44.43-2.6,1.26-3.49,2.48-.89,1.22-1.54,2.99-1.95,5.29s-.61,5.38-.61,9.22.18,6.61.54,8.89c.36,2.28.97,4.03,1.84,5.26.86,1.22,2.03,2.08,3.49,2.56,1.46.48,3.28.72,5.44.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.19,67.26v-30.1h-5.47v-6.84l5.47-1.73v-4.18c0-3.17.43-5.66,1.3-7.49.86-1.82,2.17-3.12,3.92-3.89,1.75-.77,3.95-1.15,6.59-1.15,1.97,0,3.8.11,5.51.32,1.7.22,3.08.52,4.14.9v7.7c-.77-.05-1.72-.1-2.84-.14s-2.17-.07-3.13-.07c-1.2,0-2.15.19-2.84.58-.7.38-1.2.97-1.51,1.76-.31.79-.47,1.79-.47,2.99v2.66h23.54v8.57h-23.54v30.1h-10.66ZM302.14,67.26v-30.1h-5.47v-6.84l5.47-1.73v-2.59c0-3.26.44-5.94,1.33-8.03.89-2.09,2.27-3.62,4.14-4.61,1.87-.98,4.34-1.48,7.42-1.48,1.68,0,3.21.12,4.61.36,1.39.24,2.52.48,3.38.72v7.63h-5.9c-1.1,0-1.96.17-2.56.5-.6.34-1.03.85-1.3,1.55-.26.7-.4,1.62-.4,2.77v3.17h9.86v8.57h-9.86v30.1h-10.73Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "34.17 52.53 8 69.57 8 73 17.39 73 41.5 57.3 34.17 52.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.83 52.53 75 35.49 75 25.94 41.5 47.76 48.83 52.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,25c2.21,0,4-1.79,4-4v-5h-8v5c0,2.21,1.79,4,4,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,4c0-2.21-1.79-4-4-4s-4,1.79-4,4v4h8v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75,16v9.94l8-5.21v-8.73c0-2.21-1.79-4-4-4h-16v8h12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75 69.57 83 74.78 83 30.28 75 35.49 75 69.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.39 73 5.1 81 77.89 81 65.6 73 17.39 73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "8 35.49 0 30.28 0 74.78 8 69.57 8 35.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,16h12v-8H4c-2.21,0-4,1.79-4,4v8.74l8,5.21v-9.95Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28,
    y: 8,
    width: 27,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63,4c0-2.21-1.79-4-4-4s-4,1.79-4,4v4h8v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,25c2.21,0,4-1.79,4-4v-5h-8v5c0,2.21,1.79,4,4,4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.5 57.3 65.6 73 75 73 75 69.57 48.83 52.53 41.5 57.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.5 47.76 8 25.95 8 35.49 34.17 52.53 41.5 47.76"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f4ef6536b96f1d8da9a8fda736732548.svg";
export { ForwardRef as ReactComponent };